import { Link } from 'react-router-dom';
import { FiLink } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { fallbackCopyTextToClipboard, translate } from '@utils';
import { Paths } from '@constants/paths';
import { useDispatch } from 'react-redux';
import { setNotification } from '@actions/appActions';
import { CompaniesEnum, LangEnum } from '@enums';
import ventionLogo from '@images/logoVention-black.png';
import itechartLogo from '@images/logo-black.png';
import ventionWhiteLogo from '@images/logoVention-white.png';
import itechartWhiteLogo from '@images/logo-white.png';
import { useState } from 'react';

interface props {
  id: number;
  lang: LangEnum;
  title: string;
  company: CompaniesEnum;
}

export const QuestionnaireItem = ({ id, lang, title, company }: props) => {
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const companyLogo =
    company === CompaniesEnum.Itechart
      ? {
          defaultLogo: itechartLogo,
          hoveredLogo: itechartWhiteLogo,
        }
      : {
          defaultLogo: ventionLogo,
          hoveredLogo: ventionWhiteLogo,
        };

  const handleCopyToClipboard = async (id: number): Promise<void> => {
    const value = `${window.location.origin}${Paths.QUESTIONNAIRE}/${id}`;
    try {
      await window.navigator.clipboard.writeText(value);
    } catch (err) {
      fallbackCopyTextToClipboard(value);
    } finally {
      dispatch(setNotification({ textKey: 'copied_to_clipboard', variant: 'success' }));
    }
  };
  return (
    <Link target="_blank" to={`${Paths.QUESTIONNAIRE}/${id}`}>
      <div key={id} className="questionnaire-list__item">
        <div
          className="questionnaire-list__item__content"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="questionnaire-list__item__lang">
            <IconButton
              disableRipple
              size="medium"
              onClick={(e) => {
                e.preventDefault();
                handleCopyToClipboard(id);
              }}
            >
              <FiLink className="questionnaire-list__item__icon" fontSize="inherit" />
              <span className="questionnaire-list__item__text">{translate('copy_link')}</span>
            </IconButton>
            <div data-testid={`item-${id}-lang-label`}>{lang}</div>
          </div>
          <div className="questionnaire-list__item__link">
            <div data-testid="questionnaire-list__item__link">{title}</div>
            <img
              data-testid="questionnaire-list__item__logo"
              className="questionnaire-list__item__logo"
              src={!isHovered ? companyLogo.defaultLogo : companyLogo.hoveredLogo}
              alt={'logo-' + company}
            />
          </div>
        </div>
      </div>
    </Link>
  );
};
